import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';
import veterinaryDog from '@assets/images/veterinary-dog.webp';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: 'e2b469b1-9f50-42c8-bbad-23903f658f60',
	[AppLanguageCodes.SK]: 'e2b469b1-9f50-42c8-bbad-23903f658f60',
	[AppLanguageCodes.DE]: 'e2b469b1-9f50-42c8-bbad-23903f658f60',
}


export const Veterinary = () => {

	return (
		<div className='veterinary'>
			
			<div className='veterinary-photo'>
				<img src={veterinaryDog} alt='veterinary-photo-dog' />
			</div>

			<MdxDiv className='veterinary-text' articleIds={articleIds}>
			</MdxDiv>
		
		</div>
	)
}